import type { ReactElement } from 'react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import Separator from '@ui-kit/components/layoutComponents/Separator/index.web'
import { body1 } from '@ui-kit/core/typography'
import { bgColor, textColor } from '@ui-kit/styles/colors'
import { gapY as gapYStyle } from '@ui-kit/styles/gap'

import * as styles from './styles'
import type { LineListItem as LineListItemProps, Props } from './types'

const LineListItem = (props: LineListItemProps & { labelVariant: 'body2' | 'h5' }) => {
  const { mainItem, label, rightGroup, value, subItemsList, subItem } = styles.lineListItem({
    labelVariant: props.labelVariant,
    isBold: props.isBold,
    isValueBody1: props.isBodySize,
    isValueBold: props.config?.boldValue,
    isCrossedOut: props?.config?.crossedOut,
    isValueHighlighted: props?.config?.valueHighlight,
  })
  return (
    <li key={props.key}>
      <div className={mainItem()}>
        <span className={twMerge(label({ className: textColor({ color: props.labelColor }) }))}>
          {props.label}
        </span>
        <div
          className={rightGroup({
            className: bgColor({ color: props?.config?.valueHighlightColor }),
          })}
        >
          {props.value ? (
            <span
              className={twMerge(
                value({
                  className: textColor({ color: props.valueColor }),
                })
              )}
            >
              {props.value}
            </span>
          ) : null}
          {props.component}
        </div>
      </div>

      {props.subItems && props.subItems.length > 0 && (
        <ul className={subItemsList()}>
          {props.subItems.map((item) => (
            <li className={subItem()} key={item.key}>
              {`${item.label} ${item.value ? item.value : ''}`}
            </li>
          ))}
        </ul>
      )}
    </li>
  )
}

const LineList = (props: Props): ReactElement => {
  const { container, dataContainer } = styles.lineListContainer()
  return (
    <div className={container()}>
      {props.listLabel !== undefined && <p className={body1()}>{props.listLabel}</p>}
      <ul
        className={dataContainer({
          className: props.gapY ? gapYStyle({ space: props.gapY }) : undefined,
        })}
      >
        {props.data.map((item) => {
          if ('label' in item) {
            return (
              <LineListItem
                {...item}
                key={item.key}
                labelVariant="body2"
                isBold={item.isBold ?? props.isBoldLabel}
              />
            )
          }
          if ('type' in item && item.type === 'separator') {
            return <Separator {...item} key={item.key} />
          }
          throw new Error('Item in the LineList not supported')
        })}
        {props.summaryData && <Separator space="none" color="grey500" />}
        {props.summaryData?.map((item) => (
          <LineListItem {...item} key={item.key} labelVariant="h5" />
        ))}
      </ul>
    </div>
  )
}

export default LineList
